<m-periodpicker v-bind="periodPickerProps"
                @input="updateValue"
                ref="periodpicker"
                :disabled="disabled"
                :convert-to-iso="convertToIso"
                :waiting="waiting"
                :error="error"
                :valid="valid"
                :readonly="readonly"
                :max-width="maxWidth"
                :error-message="errorMessage"
                :valid-message="validMessage"
                :helper-message="helperMessage">
    <m-datepicker :label="labelFrom"
                  :max-width="maxWidth"
                  :hide-internal-error-message="hideInternalErrorMessage"
                  :skip-input-validation="skipInputValidation"
                  :required-marker="requiredMarker"
                  slot="first"
                  slot-scope="{ props, handlers }"
                  v-on="handlers"
                  v-bind="props"></m-datepicker>
    <m-datepicker :label="labelTo"
                  :max-width="maxWidth"
                  :hide-internal-error-message="hideInternalErrorMessage"
                  :skip-input-validation="skipInputValidation"
                  :required-marker="requiredMarker"
                  slot="second"
                  slot-scope="{ props, handlers }"
                  v-on="handlers"
                  v-bind="props"></m-datepicker>
</m-periodpicker>
